//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LineageTableau',
  props: {
    datos: {
      type: Object,
      default: function _default() {}
    },
    classMain: {
      type: String,
      default: 'lineage-dataset'
    }
  }
};